
// import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import type { RootState } from '../../store';
// import type { Contact } from '@/types/contact';
// import { ContactsState } from './types';
// import { updateContactInState } from './contactsReducerUtils';
// import {
//   fetchCustomers,
//   fetchVisitors,
//   fetchContactDetails,
//   updateContact,
//   updateContactCompany,
//   addContact,
//   fetchContacts
// } from './contactsActions';

// const initialState: ContactsState = {
//   contacts: [],
//   items: [], // For backward compatibility
//   contactDetails: null,
//   selectedContact: null,
//   selectedContacts: [],
//   loading: false,
//   error: null,
//   lastFetchTime: null,
//   visitors: [],
//   customers: [],
//   visitorsLoading: false,
//   customersLoading: false,
//   visitorsError: null,
//   customersError: null
// };

// const contactsSlice = createSlice({
//   name: 'contacts',
//   initialState,
//   reducers: {
//     setSelectedContacts: (state, action: PayloadAction<string[]>) => {
//       state.selectedContacts = action.payload;
//     },
//     clearSelectedContacts: (state) => {
//       state.selectedContacts = [];
//     },
//     toggleSelectContact: (state, action: PayloadAction<string>) => {
//       const contactId = action.payload;
//       if (state.selectedContacts.includes(contactId)) {
//         state.selectedContacts = state.selectedContacts.filter(id => id !== contactId);
//       } else {
//         state.selectedContacts.push(contactId);
//       }
//     },
//     selectContact: (state, action: PayloadAction<string>) => {
//       state.selectedContact = state.contacts.find(contact => contact.id === action.payload) || null;
//     },
//     clearSelection: (state) => {
//       state.selectedContacts = [];
//     },
//     clearContactsData: (state) => {
//       state.contacts = [];
//       state.items = [];
//       state.lastFetchTime = null;
//     }
//   },
//   extraReducers: (builder) => {
//     // Customer handling
//     builder
//       .addCase(fetchCustomers.pending, (state) => {
//         state.customersLoading = true;
//         state.customersError = null;
//       })
//       .addCase(fetchCustomers.fulfilled, (state, action) => {
//         state.customersLoading = false;
//         if (action.payload) {
//           state.customers = action.payload;
//           // Don't update all contacts here to keep visitors separate
//           state.lastFetchTime = Date.now();
//         }
//       })
//       .addCase(fetchCustomers.rejected, (state, action) => {
//         state.customersLoading = false;
//         state.customersError = action.payload as string || 'Failed to fetch customers';
//       });

//     // Visitor handling
//     builder
//       .addCase(fetchVisitors.pending, (state) => {
//         state.visitorsLoading = true;
//         state.visitorsError = null;
//       })
//       .addCase(fetchVisitors.fulfilled, (state, action) => {
//         state.visitorsLoading = false;
//         if (action.payload) {
//           state.visitors = action.payload;
//           // Don't update all contacts here to keep customers separate
//           state.lastFetchTime = Date.now();
//         }
//       })
//       .addCase(fetchVisitors.rejected, (state, action) => {
//         state.visitorsLoading = false;
//         state.visitorsError = action.payload as string || 'Failed to fetch visitors';
//       });

//     // All contacts handling (for the All Contacts page)
//     builder
//       .addCase(fetchContacts.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchContacts.fulfilled, (state, action) => {
//         state.loading = false;
//         if (action.payload) {
//           state.contacts = action.payload;
//           state.items = action.payload; // For backward compatibility
//           state.lastFetchTime = Date.now();
//         }
//       })
//       .addCase(fetchContacts.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string || 'Failed to fetch contacts';
//       });

//     // Contact details handling
//     builder
//       .addCase(fetchContactDetails.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchContactDetails.fulfilled, (state, action) => {
//         state.loading = false;
//         state.contactDetails = action.payload;
//       })
//       .addCase(fetchContactDetails.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string || 'Failed to fetch contact details';
//       });

//     // Add contact handling
//     builder
//       .addCase(addContact.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(addContact.fulfilled, (state, action) => {
//         state.loading = false;
//         state.contacts.push(action.payload);
//         state.items.push(action.payload);
//         // Add to appropriate list based on contact type
//         if (action.payload.type === 'customer') {
//           state.customers.push(action.payload);
//         } else if (action.payload.type === 'visitor') {
//           state.visitors.push(action.payload);
//         }
//       })
//       .addCase(addContact.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string || 'Failed to add contact';
//       });

//     // Update contact handling
//     builder
//       .addCase(updateContact.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateContact.fulfilled, (state, action) => {
//         state.loading = false;
//         updateContactInState(state, action.payload.contactId, action.payload.data);
//       })
//       .addCase(updateContact.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string || 'Failed to update contact';
//       });

//     // Update contact company handling  
//     builder
//       .addCase(updateContactCompany.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(updateContactCompany.fulfilled, (state, action) => {
//         state.loading = false;
//         updateContactInState(state, action.payload.contactId, action.payload.data);
//       })
//       .addCase(updateContactCompany.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string || 'Failed to update contact company';
//       });
//   }
// });

// export const {
//   setSelectedContacts,
//   clearSelectedContacts,
//   toggleSelectContact,
//   selectContact,
//   clearSelection,
//   clearContactsData
// } = contactsSlice.actions;

// // Re-export selectors from contactsSelectors.ts
export * from './contactsSelectors';

// // Re-export actions from contactsActions.ts
export {
  // fetchCustomers,
  fetchVisitors,
  fetchContactDetails,
  // addContact,
  // updateContact,
  updateContactCompany,
  fetchContacts
} from './contactsActions';

// // Export the reducer
// export default contactsSlice.reducer;



import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import type { ContactsState } from './types';
import type { Contact } from '@/types/contact';
import { CreateCustomerData, customerService } from '@/api/services/customerService';

const initialState: ContactsState = {
  contacts: [],
  contactDetails: null,
  loading: false,
  error: null,
  selectedContacts: [],
  lastFetchTime: null,
  areContactsLoaded: false,
  items: [],
  selectedContact: undefined,
  visitors: [],
  visitorsLoading: false,
  visitorsError: '',
  customers: [],
  customersLoading: false,
  customersError: ''
};

// ✅ Fetch customers from API
export const fetchCustomers = createAsyncThunk(
  'customers/fetchCustomers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await customerService.fetchCustomers();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch customers');
    }
  }
);

// ✅ Get customer details
export const fetchCustomerDetails = createAsyncThunk(
  'customers/fetchCustomerDetails',
  async (customer_id: string, { rejectWithValue }) => {
    try {
      const customer = await customerService.getCustomerDetails(customer_id);
      return customer.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch customer details');
    }
  }
);

// ✅ Create a new customer
export const createCustomer = createAsyncThunk(
  'customers/createCustomer',
  async (customerData: Partial<Contact> & { workspace_id: string }, { rejectWithValue }) => {
    try {
      // Ensure required fields are strictly strings
      const formattedCustomerData: CreateCustomerData = {
        firstname: String(customerData.firstname || ''),
        lastname: String(customerData.lastname || ''),
        email: String(customerData.email || ''),
        workspace_id: customerData.workspace_id,
        type: customerData.type ? String(customerData.type) : undefined,
        phone: customerData.phone ? String(customerData.phone) : undefined,
        phoneCountry: customerData.phoneCountry ? String(customerData.phoneCountry) : undefined,
        companyId: customerData.companyId ? String(customerData.companyId) : undefined,
      };

      const newCustomer = await customerService.createCustomer(formattedCustomerData);
      return newCustomer;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to create customer');
    }
  }
);

// ✅ Update a customer
export const updateCustomer = createAsyncThunk(
  'customers/updateCustomer',
  async (customerData: Partial<Contact> & { customer_id: string }, { rejectWithValue }) => {
    try {
      // Extract customer_id from the payload to avoid sending it as part of the data
      const { customer_id, ...dataToUpdate } = customerData;

      const updatedCustomer = await customerService.updateCustomer(customer_id, dataToUpdate);
      return updatedCustomer;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to update customer');
    }
  }
);

// ✅ Bulk update customers
export const bulkUpdateCustomers = createAsyncThunk(
  'customers/bulkUpdateCustomers',
  async (data: { customerIds: string[], archived?: boolean, tagIds?: string[] }, { rejectWithValue }) => {
    try {
      await customerService.bulkUpdateCustomers(data);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to bulk update customers');
    }
  }
);


// ✅ Import customers from CSV
export const importCustomers = createAsyncThunk(
  'customers/importCustomers',
  async (csvFile: File, { rejectWithValue }) => {
    try {
      await customerService.importCustomers(csvFile);
      return 'Customers imported successfully';
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to import customers');
    }
  }
);
// ✅ Add a new contact
export const addContact = createAsyncThunk(
  'customers/addContact',
  async (contactData: Partial<Contact>, { rejectWithValue }) => {
    try {
      // Format contact data to match CreateCustomerData requirements
      const formattedContactData: CreateCustomerData = {
        firstname: String(contactData.firstname || ''),
        lastname: String(contactData.lastname || ''),
        email: String(contactData.email || ''),
        workspace_id: String(contactData.workspaceId || ''),
        type: contactData.type ? String(contactData.type) : undefined,
        phone: contactData.phone ? String(contactData.phone) : undefined,
        phoneCountry: contactData.phoneCountry ? String(contactData.phoneCountry) : undefined,
        companyId: contactData.companyId ? String(contactData.companyId) : undefined,
      };
      const newContact = await customerService.createCustomer(formattedContactData);
      return newContact.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to add contact');
    }
  }
);


const customerSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    setSelectedContacts: (state, action) => {
      state.selectedContacts = action.payload;
    },
    toggleContactSelection: (state, action) => {
      const contactId = action.payload;
      const index = state.selectedContacts.indexOf(contactId);
      if (index === -1) {
        state.selectedContacts.push(contactId);
      } else {
        state.selectedContacts.splice(index, 1);
      }
    },
    updateContact: (state, action) => {
      const { id, ...updates } = action.payload;
      const contact = state.contacts.find((c) => c.id === id);
      if (contact) {
        Object.assign(contact, updates);
      }
    },
    clearSelectedContacts: (state) => {
      state.selectedContacts = [];
    },
    selectContact: (state, action: PayloadAction<string>) => {
      state.selectedContact = state.contacts.find(contact => contact.id === action.payload) || null;
    },
    clearSelection: (state) => {
      state.selectedContacts = [];
    },
    clearContactsData: (state) => {
      state.contacts = [];
      state.items = [];
      state.lastFetchTime = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.contacts = action.payload;
        state.lastFetchTime = Date.now();
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchCustomerDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
        // Clear previous contact details to avoid showing stale data
        state.contactDetails = null;
      })
      .addCase(fetchCustomerDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.contactDetails = action.payload;
      })
      .addCase(fetchCustomerDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(importCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(importCustomers.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(importCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateCustomer.pending, (state) => {
        state.error = null;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        if (state.contactDetails && action.payload) {
          const apiResponse = action.payload;

          // Create a complete merged object
          state.contactDetails = {
            ...state.contactDetails,
            ...apiResponse,
            // Set default values for null fields
            status: (apiResponse.status || state.contactDetails.status || 'active') as 'active' | 'inactive',
          };
        }
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.error = action.payload as string;
      })
      .addCase(addContact.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addContact.fulfilled, (state, action) => {
        state.loading = false;
        state.contacts = [...state.contacts, action.payload];
      })
      .addCase(addContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(bulkUpdateCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bulkUpdateCustomers.fulfilled, (state, action) => {
        state.loading = false;
        const { customerIds, archived, tagIds } = action.payload;

        if (archived) {
          state.contacts = state.contacts.filter(contact => !customerIds.includes(contact.id));
        }

        if (tagIds) {
          // This is a simplified update. A real implementation might need to fetch tag details.
          const newTags = tagIds.map(id => `Tag ${id}`);
          state.contacts.forEach(contact => {
            if (customerIds.includes(contact.id)) {
              contact.tags = newTags;
            }
          });
        }
      })
      .addCase(bulkUpdateCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setSelectedContacts, toggleContactSelection, updateContact, clearContactsData, clearSelectedContacts, clearSelection } = customerSlice.actions;
export default customerSlice.reducer;
